import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setLoading, setNotifications) =>
{
    setLoading(true);    

    try 
    {

        const [freshcount, warmcount, pendingcount, todaycount, followupdata] = await Promise.all([
                                                                      baseapi.get("/api/caller/dashboard/fresh-lead-count"),
                                                                      baseapi.get("/api/caller/dashboard/warm-lead-count"),
                                                                      baseapi.get("/api/caller/dashboard/pending-followup-count"),
                                                                      baseapi.get("/api/caller/dashboard/today-followup-count"),
                                                                      baseapi.get("/api/caller/dashboard/today-followup"),
                                                                ]);
        
        setLoading(false);

        console.log(warmcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setFollowupCount(pendingcount.data.datacount);
        setTodayFollowupCount(todaycount.data.datacount);
        setWarmLeadCount(warmcount.data.datacount);
        setNotifications(followupdata.data.datalist);

        /*return {
            freshcount: freshcount.data.datacount,
            warmcount: warmcount.data.datacount,
            pendingfollowup: pendingcount.data.datacount,
            todayfollowup: todaycount.data.datacount,
            followuplist: followupdata.data.datalist,
        };*/
        //const response = await baseapi.get("/api/caller/dashboard");

        //console.log("Data got successfully", response.data);
        
        /*setFreshLeadCount(response.data.leadcount.freshlead);
        setFollowupCount(response.data.notification.total_pending);
        setTodayFollowupCount(response.data.notification.today_pending);
        setWarmLeadCount(response.data.leadcount.warmleads);
        setContactedLeadCount(response.data.leadcount.contactedleads);
        setDeadLeadCount(response.data.leadcount.deadleads);
        setColdLeadCount(response.data.leadcount.coldleads);
        setAttemptLeadCount(response.data.leadcount.attemptleads);
        setEnrolledLeadCount(response.data.leadcount.enrolledleads);
        setTotalLeadCount(response.data.leadcount.totallead);
        setNotifications(response.data.todaynotify);*/

        
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

/*export const DashboardAPI = async (setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setContactedLeadCount, setDeadLeadCount, setColdLeadCount, setAttemptLeadCount, setEnrolledLeadCount, setLoading, setNotifications, setTotalLeadCount) =>
{
    //setLoading(true);    

    try 
    {
        const response = await baseapi.get("/api/caller/dashboard");

        //console.log("Data got successfully", response.data);
        
        setFreshLeadCount(response.data.leadcount.freshlead);
        setFollowupCount(response.data.notification.total_pending);
        setTodayFollowupCount(response.data.notification.today_pending);
        setWarmLeadCount(response.data.leadcount.warmleads);
        setContactedLeadCount(response.data.leadcount.contactedleads);
        setDeadLeadCount(response.data.leadcount.deadleads);
        setColdLeadCount(response.data.leadcount.coldleads);
        setAttemptLeadCount(response.data.leadcount.attemptleads);
        setEnrolledLeadCount(response.data.leadcount.enrolledleads);
        setTotalLeadCount(response.data.leadcount.totallead);
        setNotifications(response.data.todaynotify);

        setLoading(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}*/

